import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { listSteps } from './MailCheckHelpers';
import { useDispatch } from 'react-redux';
import { FundingLayout } from '../Shared/FundingPageLayout/FundingLayout';
import Stepper from '../Shared/Stepper/Stepper';
import FundingReviewSummary from '../Shared/FundingReviewSummary/FundingReviewSummary';
import { MailCheckConstants } from './MailCheckConstants';
import Faq from '../Shared/Faq/Faq';
import {
  getUserFundingInfo,
  NotApplicable,
} from '../../redux/modules/fundingTrackingData/fundingTrackingData.module';
import { getUrlParams } from '../../utils/link-helper';
import './MailCheck.scss';
import { FullPageLoader } from '../Shared/FullPageLoader/FullPageLoader';
import { APP_FAILURE } from '../../settings/settings';
import {
  getPersonalInformation,
  getUserMessages,
} from '../../redux/modules/user/PersonalInformation/PersonalInformation.module';
import { getProductTypes } from '../../redux/modules/productTypes/productType.module';
export const getError = (applicationState) => {
  if (applicationState.hasFailed) {
    return {
      type: APP_FAILURE,
      hasError: true,
    };
  }
  return {
    type: '',
    hasError: false,
  };
};
const MailCheck = () => {
  const dispatch = useDispatch();
  const [filteredSteps, setFilteredSteps] = useState([]);
  const [showNextPage, setShowNextPage] = useState(false);
  const currentStep = useSelector((state) => state?.currentStep?.initialState);
  const fundingTrackingData = useSelector(
    (state) => state?.fundingTrackingData
  );
  const [applicationState, setApplicationState] = useState({
    hasFailed: false,
    isLoading: true,
    isLoaded: false,
  });

  useEffect(() => {
    setFilteredSteps(listSteps);
  }, [filteredSteps]);

  /* eslint-disable */
  useEffect(() => {
    if (
      fundingTrackingData?.isLoading !== undefined &&
      fundingTrackingData?.isLoaded !== undefined &&
      fundingTrackingData?.hasFailed !== undefined
    ) {
      setApplicationState({
        ...applicationState,
        hasFailed: fundingTrackingData?.hasFailed,
        isLoaded: fundingTrackingData?.isLoaded,
        isLoading: fundingTrackingData?.isLoading,
      });
    }
  }, [
    fundingTrackingData?.isLoading,
    fundingTrackingData?.isLoaded,
    fundingTrackingData?.hasFailed,
  ]);

  const handleClick = () => {
    setShowNextPage(true);
  };

  /* eslint-disable */
  useEffect(() => {
    const url = window.location.href;
    const searchParams = getUrlParams(url);
    if (searchParams?.selectedAgreementID) {
      const fetchMailCheckDetails = async () => {
        const url = window.location.href;
        const searchParams = getUrlParams(url);
        dispatch(
          getUserFundingInfo(
            searchParams?.selectedAgreementID,
            MailCheckConstants.labels.MailCheck
          )
        );
        dispatch(getPersonalInformation());
        dispatch(getUserMessages());
        dispatch(dispatch(getProductTypes()));
      };
      fetchMailCheckDetails();
    } else {
      dispatch(NotApplicable());
    }
  }, []);

  const message = '';
 

  return (
    <div className="mail-check-container">
      <FullPageLoader
        isVisible={applicationState.isLoading}
        hasError={getError(applicationState).hasError}
        errorType={getError(applicationState).type}
        messages={message}
      />
      {applicationState?.isLoaded &&
        !applicationState?.hasFailed &&
        !applicationState?.isLoading &&
        !showNextPage && (
          <FundingLayout
            listSteps={filteredSteps}
            leftSection={filteredSteps[currentStep]?.component}
            wizard={
              filteredSteps[currentStep]?.showWizard && (
                <Stepper listSteps={listSteps} />
              )
            }
            faqSection={<Faq endPoint="faqMailACheck" />}
            summary={
              filteredSteps[currentStep]?.summary && (
                <FundingReviewSummary
                  fundingMethodType={
                    MailCheckConstants.transferReviewPage.fundingMethodType
                  }
                  handleClick={handleClick}
                />
              )
            }
          />
        )}
      {showNextPage && <div>Next page</div>}
    </div>
  );
};
export default MailCheck;